'use strict';

var React = require('react');
var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var styled = require('styled-components');
var components_FoodItem_helpers_index = require('./index-2bhV6eMA.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Strike = styled__default.default(Text.Text)(({ theme }) => ({
    textDecoration: "line-through",
    marginRight: theme.spacing.xxSmall,
}));
const Price = styled__default.default.span `
    & > *::before {
        content: "\\20B9";
        margin-right: 0.1rem;
    }

    margin-right: ${({ variant }) => (variant === "secondary" ? "4px" : 0)};
`;
const Flex = styled__default.default.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing.xxSmall,
}));

function PriceV4({ price = 0, finalPrice = price, variant = "primary", divideByHundred = true, customVariant, customColor, }) {
    const priceVar = components_FoodItem_helpers_index.inRupee(price, divideByHundred);
    const finalPriceVar = components_FoodItem_helpers_index.inRupee(finalPrice, divideByHundred);
    const showFinalPriceValue = components_FoodItem_helpers_index.showFinalPrice(priceVar, finalPriceVar);
    return (React__default.default.createElement(Flex, { "aria-hidden": "true" },
        showFinalPriceValue && variant === "primary" && (React__default.default.createElement(Price, null,
            React__default.default.createElement(Strike, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, priceVar))),
        React__default.default.createElement(Price, { variant: variant },
            React__default.default.createElement(Text.Text, { color: customColor || "text_Med_Emphasis", variant: customVariant || "V2.body2.neutral.regular" }, finalPriceVar)),
        showFinalPriceValue && variant === "secondary" && (React__default.default.createElement(Price, null,
            React__default.default.createElement(Strike, { color: "text_Med_Emphasis", variant: "V2.body2.neutral.regular" }, priceVar)))));
}
var PriceV4$1 = React.memo(PriceV4);

exports.PriceV4 = PriceV4$1;
//# sourceMappingURL=PriceV4-CAdVMHnO.js.map
